const choices = {
    none: 'Aucun',
    partial: 'Partiel',
    total: 'Total',
};

export default choices;
